/**
 * Thin axios wrappers around /api/ask/config.
 *
 * `effective` is the one worth knowing about: it answers "which model is each
 * role ACTUALLY using right now", including whether it fell back to the
 * platform. Without it a team can configure one slot, assume everything runs on
 * their key, and only discover otherwise on an invoice.
 */
import axiosInstance from 'shared/services/api/axiosInstance';

const tparams = (teamId, extra = {}) => ({ params: { team_id: teamId, ...extra } });

export async function getAskConfig(teamId) {
  const { data } = await axiosInstance.get('/ask/config', tparams(teamId));
  return data || { config: null, fallbacks: {}, own_models: false, org_team_count: 1 };
}

export async function saveAskConfig(teamId, body) {
  const { data } = await axiosInstance.put('/ask/config', { ...body, team_id: teamId }, tparams(teamId));
  return data?.config;
}

export async function probeAskSlot(teamId, { integrationId, model, role }) {
  const { data } = await axiosInstance.post(
    '/ask/config/probe',
    { team_id: teamId, integration_id: integrationId, model, role },
    tparams(teamId),
  );
  return data;
}

export async function getEffectiveModels(teamId) {
  const { data } = await axiosInstance.get('/ask/config/effective', tparams(teamId));
  return data?.effective || {};
}
